import { withSession } from '@zipdrug/react-api-sdk';
import { queryPharmacyServices } from 'graphql/pharmacyServices';
import { get } from 'lodash';
import { graphql } from 'react-apollo';
import React from 'react';
import fetchOnceOptions from './utils/fetchOnceOptions';

const withPharmacyServices = Component =>
  graphql(queryPharmacyServices, {
    skip: ({ pharmacyIdsForServices }) =>
      !pharmacyIdsForServices || pharmacyIdsForServices?.length === 0,
    options: ({ pharmacyIdsForServices }) =>
      fetchOnceOptions('pharmacyServices', {
        variables: {
          ids: pharmacyIdsForServices,
        },
      }),
    props: ({ data: { pharmacyServices: result } }) => ({
      pharmacyServices: get(result, 'data'),
    }),
  })(Component);

export default Component => {
  // Wrapper component to replace mapProps
  const PharmacyServicesMapper = (props) => {
    const { pharmacyServices, ...restProps } = props;
    
    return <Component pharmacyServices={pharmacyServices} {...restProps} />;
  };

  // Manual HOC composition (previously done by compose)
  const PharmacyServicesEnhanced = withPharmacyServices(PharmacyServicesMapper);
  const SessionEnhanced = withSession(PharmacyServicesEnhanced);
  
  return SessionEnhanced;
};
